import type { AiBusinessCenterModule } from '../types'

export const wmsModule: AiBusinessCenterModule = {
  key: 'wms',
  label: 'WMS仓储系统',
  desc: '入库管理 / 出库管理 / 库存盘点 / 库位管理',
  path: '/wms',
  homePath: '/wms/home',
  icon: 'ep:box',
  color: '#10b981',
  aliases: ['WMS 仓储系统', 'WMS仓储管理', 'WMS', '仓储管理']
}
